import React from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import swal from "sweetalert2";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faTrash } from '@fortawesome/free-solid-svg-icons';

const  DeleteActionButton = (props) => {
    const t = useTranslate();

    return (
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip>
                        {t(props.nameType)}
                    </Tooltip>
                }
            >
                <span 
                    className={`${props.spanClass || "text-danger"}`}
                    style={{cursor:'pointer',...(props.spanStyle || {})}} 
                    onClick={() => {
                        swal
                        .fire({
                            title: t(props.actionType)+" "+props.toDelete+"?",
                            icon: "warning",
                            type: "question",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: t('btnYes'),
                            cancelButtonText: t('btnNo'),
                        })
                        .then((result) => {
                            if (result.value) {
                                props.customClickEvent(props.deleteFunctionArgument)
                            }
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </span>
            </OverlayTrigger>  
    )
}

export default DeleteActionButton;